import React, { Component } from 'react'

import i18n from '../../i18n'

import IconBackgroundCheck from '../../images/shared/icon-background-check-white.png'
import IconAcademyInformations from '../../images/shared/icon-academy-informations-white.png'
import IconAdditionalProfessors from '../../images/shared/icon-additional-professors-white.png'
import IconAssociation from '../../images/shared/icon-association-white.png'
import IconSafeSport from '../../images/shared/icon-safe-sport-white.png'
import IconPayment from '../../images/shared/icon-payment-white.png'

import Step from './Step'

const membershipSteps = {
  form: {
    title: i18n.t('membership.steps.form'),
    description: i18n.t('membership.steps.descriptions.form'),
  },
  photo: {
    title: i18n.t('membership.steps.photo'),
    description: i18n.t('membership.steps.descriptions.photo'),
  },
  id: {
    title: i18n.t('membership.steps.identification'),
    description: i18n.t('membership.steps.descriptions.identification'),
  },
  parentId: {
    title: i18n.t('membership.steps.parentId'),
    description: i18n.t('membership.steps.descriptions.parentId'),
  },
  beltRecords: {
    title: i18n.t('membership.steps.beltRecords'),
    description: i18n.t('membership.steps.descriptions.beltRecords'),
  },
  medicalWaiver: {
    title: i18n.t('membership.steps.medicalWaiver'),
    description: i18n.t('membership.steps.descriptions.medicalWaiver'),
  },
}

const academyRegistrationSteps = {
  bgCheck: {
    title: i18n.t('academyRegistration.steps.bgCheck.title'),
    icon: IconBackgroundCheck,
    description: i18n.t('academyRegistration.steps.bgCheck.description'),
    linkLabel: 'Read more and Apply',
    linkUrl: '/background-check',
  },
  safeSport: {
    title: i18n.t('academyRegistration.steps.safeSport.title'),
    icon: IconSafeSport,
    description: i18n.t('academyRegistration.steps.safeSport.description'),
    linkLabel: 'Read more and Apply',
    linkUrl: '/safe-sport',
  },
  academyForm: {
    title: i18n.t('academyRegistration.steps.academyForm.title'),
    icon: IconAcademyInformations,
    description: i18n.t('academyRegistration.steps.academyForm.description'),
    linkLabel: i18n.t('academyRegistration.stepsReadMore'),
    linkUrl: '/academy-registration-informations',
  },
  additionalProfessors: {
    title: i18n.t('academyRegistration.steps.additionalProfessors.title'),
    icon: IconAdditionalProfessors,
    description: i18n.t(
      'academyRegistration.steps.additionalProfessors.description'
    ),
  },
  association: {
    title: i18n.t('academyRegistration.steps.association.title'),
    icon: IconAssociation,
    description: i18n.t('academyRegistration.steps.association.description'),
  },
}

class StepsByDocs extends Component {
  constructor(props) {
    super(props)

    this.state = {
      rawSteps: {
        membership: {
          form: [
            'membershipFormAdult',
            'membershipFormLessThan16YearsOld',
            'membershipFormLessThan18YearsOld',
          ],
          photo: 'photo',
          id: 'identification',
          parentId: 'identificationLegalParent',
          beltRecords: 'beltRecords',
          medicalWaiver: ['medicalWaiver', 'portugalMedicalWaiver'],
          payment: 'payment',
        },
        academyRegistration: {
          bgCheck: 'backgroundCheck',
          safeSport: 'safeSport',
          academyForm: 'academyForm',
          additionalProfessors: 'assistantProfessorsApproval',
          association: 'associationApproval',
          payment: 'payment',
        },
      },
      stepsList: [],
    }
  }

  componentDidMount() {
    this.selectSteps()
  }

  render() {
    return (
      <React.Fragment>
        {this.renderStepsHeading()}

        <div className="steps">
          {this.state.stepsList.map((step, i) => this.renderStep(step, i))}
        </div>
      </React.Fragment>
    )
  }

  renderStepsHeading() {
    if (this.props.type === 'academyRegistration') {
      return (
        <div className="academy-registration-steps-heading">
          {i18n.t('academyRegistration.stepsHeading', {
            stepsCount: this.state.stepsList.length,
          })}
        </div>
      )
    }
  }

  stepsList() {
    return eval(this.props.type + 'Steps')
  }

  selectSteps() {
    const stepsByType = this.state.rawSteps[this.props.type]
    const keys = Object.keys(stepsByType)
    const stepsList = this.stepsList()
    let newStepsList = Array.from(this.state.stepsList)

    keys.forEach((rawStep) => {
      let rawStepValue = stepsByType[rawStep]
      if (Array.isArray(stepsByType[rawStep])) {
        this.props.docs.forEach((doc) => {
          if (rawStepValue.includes(doc)) {
            newStepsList.push(stepsList[rawStep])
          }
        })
      } else {
        if (this.props.docs.includes(rawStepValue)) {
          newStepsList.push(stepsList[rawStep])
        }
      }
    })

    newStepsList = this.addDefaultSteps(newStepsList)
    this.setState({ stepsList: newStepsList })
  }

  addDefaultSteps(newStepsList) {
    const { type, fee, currency } = this.props

    if (type === 'membership') {
      newStepsList.push({
        title: i18n.t('membership.steps.payment'),
        description: i18n.t('membership.steps.descriptions.payment'),
        bottomInfo: i18n.t('membership.steps.processFee', {
          fee: `${currency} ${fee}`,
        }),
      })
    } else {
      // please, look over there reviewer ;D
      newStepsList.splice(2, 0, academyRegistrationSteps['academyForm'])

      newStepsList.push({
        title: i18n.t('academyRegistration.steps.payment.title'),
        icon: IconPayment,
        description: i18n.t('academyRegistration.steps.payment.description'),
        bottomInfo: i18n.t('academyRegistration.steps.payment.fee', {
          fee: `${currency} ${fee}`,
        }),
      })
    }

    return newStepsList
  }

  renderStep(step, number) {
    return (
      <Step
        key={step.id}
        title={`Step ${number + 1}`}
        subtitle={step.title}
        icon={step.icon}
        description={step.description}
        linkLabel={step.linkLabel}
        linkUrl={step.linkUrl}
        bottomInfo={step.bottomInfo}
      />
    )
  }
}

export default StepsByDocs
